import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useNavigate, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import ClassesPage from './pages/ClassesPage'
import BookPage from './pages/BookPage'
import ContactPage from './pages/ContactPage'
import PricesPage from './pages/PricesPage'
import StudioPoliciesPage from './pages/StudioPoliciesPage'
import AlgemeneVoorwaardenPage from './pages/AlgemeneVoorwaardenPage'
import PrivacyCookiesPage from './pages/PrivacyCookiesPage'
import TeambuildingsPage from './pages/TeambuildingsPage'
import FAQPage from './pages/FAQPage'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/classes" element={<ClassesPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/prices" element={<PricesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/studio-policies" element={<StudioPoliciesPage />} />
          <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaardenPage />} />
          <Route path="/privacy-cookies" element={<PrivacyCookiesPage />} />
          <Route path="/teambuildings" element={<TeambuildingsPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
        {/* <ConditionalBookButton /> */}
      </div>
    </Router>
  )
}

// Conditional booking button that doesn't show on the prices page
function ConditionalBookButton() {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Don't show the button on the prices page
  if (['/prices', '/book'].includes(location.pathname)) {
    return null
  }
  
  return (
    <button 
      onClick={() => navigate('/book')}
      className="book-button"
    >
      Boek je les
    </button>
  );
}

export default App
